export const environment = {
    gridUnitWidth: 50,
    gridUnitHeight: 50,
    gridUnitLength: 50,
    gridWidth: 1000,
    gridLength: 1000
}
